import { lazy } from 'react';

const LazyProfileDashboardView = lazy(() => import('./profile-dashboard-view'));
export default LazyProfileDashboardView;
